import React from 'react';

import JobModal from '../Boutique/JobModal';

const ClientPreviousProjectModal = ({ showModal, handleClick, demand }) => (
  <JobModal
    showModal={showModal}
    handleClick={handleClick}
    demand={demand}
    allowContract
    allowCoverUpload={false}
    viewerRole="client"
  />
);

export default ClientPreviousProjectModal;
